import { formatDateValue } from "@common";

const EMPTY_VALUE = "";

const getValue = (value) =>
  value === null || value === undefined || value === ""
    ? EMPTY_VALUE
    : value;

const formatBoolean = (val) => {
  if (val === true || val === "true" || val === "Yes") return "Yes";
  if (val === false || val === "false" || val === "No") return "No";
  return EMPTY_VALUE;
};

export const getProspectContactEngagementView = (data = {}) => {
  const left = [
    {
      label: "Engagement Level",
      value: getValue(
        typeof data?.engagementLevel === "object"
          ? data?.engagementLevel?.levelName || data?.engagementLevel?.engagementLevelName
          : data?.engagementLevel,
      ),
    },
    {
      label: "Last Contacted At",
      value: formatDateValue(data?.lastContactedAt),
    },
    {
      label: "Response Status",
      value: getValue(
        typeof data?.responseStatus === "object"
          ? data?.responseStatus?.responseStatusName
          : data?.responseStatus,
      ),
    },
    {
      label: "Email Opt-Out",
      value: formatBoolean(data?.doNotEmail),
    },
    {
      label: "Contact Opt-Out",
      value: formatBoolean(data?.doNotContact),
    },
  ];

  const right = [
    {
      label: "Relationship Status",
      value: getValue(
        typeof data?.relationshipStatus === "object"
          ? data?.relationshipStatus?.relationStatus || data?.relationshipStatus?.relationshipStatusName
          : data?.relationshipStatus,
      ),
    },
    {
      label: "Next Follow Up At",
      value: formatDateValue(data?.nextFollowUpAt),
    },
    {
      label: "Call Opt-Out",
      value: formatBoolean(data?.doNotCall),
    },
  ];

  const fullWidth = [
    {
      label: "Communication Consent",
      value: getValue(
        typeof data?.communicationConsent === "object"
          ? data?.communicationConsent?.consentName
          : data?.communicationConsent,
      ),
    },
    {
      label: "Notes",
      value: getValue(data?.notes),
    },
  ];

  return {
    left,
    right,
    fullWidth,
  };
};
